/**
 * UI Preferences — globale settings voor lettertype + tekstgrootte.
 * Wordt aangeroepen op app-start (via root component) en toegepast via CSS variabelen.
 *
 * Stored in localStorage onder key 'billfac.ui'.
 * Format: { fontFamily: 'sans'|'serif'|'mono'|'rounded', fontSize: 'sm'|'md'|'lg'|'xl' }
 */

export const FONT_FAMILY_PRESETS = [
  { key: 'sans',    label: 'Sans-Serif (modern)', stack: 'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif' },
  { key: 'serif',   label: 'Serif (klassiek)',    stack: 'Georgia, "Times New Roman", Times, serif' },
  { key: 'rounded', label: 'Afgerond',            stack: '"Comfortaa", "Nunito", system-ui, sans-serif' },
  { key: 'mono',    label: 'Monospace',           stack: '"Courier New", Consolas, "Liberation Mono", monospace' },
];

export const FONT_SIZE_PRESETS = [
  { key: 'sm', label: 'Klein',  scale: 14 },
  { key: 'md', label: 'Normaal (standaard)', scale: 16 },
  { key: 'lg', label: 'Groot',  scale: 18 },
  { key: 'xl', label: 'Extra groot (toegankelijk)', scale: 20 },
];

const DEFAULT_PREFS = {
  fontFamily: 'sans',
  fontSize: 'md',
  mailFontFamily: 'sans',  // aparte instelling voor mail-content
  mailFontSize: 'md',
};

export function loadUiPrefs() {
  try {
    const raw = localStorage.getItem('billfac.ui');
    if (!raw) return { ...DEFAULT_PREFS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_PREFS, ...parsed };
  } catch {
    return { ...DEFAULT_PREFS };
  }
}

export function saveUiPrefs(prefs) {
  try {
    localStorage.setItem('billfac.ui', JSON.stringify(prefs));
  } catch {}
  applyUiPrefs(prefs);
}

export function applyUiPrefs(prefs) {
  const family = FONT_FAMILY_PRESETS.find(f => f.key === prefs.fontFamily) || FONT_FAMILY_PRESETS[0];
  const size = FONT_SIZE_PRESETS.find(s => s.key === prefs.fontSize) || FONT_SIZE_PRESETS[1];
  const mailFamily = FONT_FAMILY_PRESETS.find(f => f.key === prefs.mailFontFamily) || family;
  const mailSize = FONT_SIZE_PRESETS.find(s => s.key === prefs.mailFontSize) || size;
  const root = document.documentElement;
  // Globaal voor heel BillFac
  root.style.setProperty('--app-font-family', family.stack);
  root.style.setProperty('--app-font-size-base', size.scale + 'px');
  document.body.style.fontFamily = family.stack;
  document.body.style.fontSize = size.scale + 'px';
  // Apart voor mail-content (.mail-content scope)
  root.style.setProperty('--mail-font-family', mailFamily.stack);
  root.style.setProperty('--mail-font-size-base', mailSize.scale + 'px');
  // Dispatch custom event zodat andere componenten kunnen reageren
  window.dispatchEvent(new CustomEvent('billfac:ui-prefs-changed', { detail: prefs }));
}

// Auto-apply bij eerste import (alleen in browser-context)
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  try { applyUiPrefs(loadUiPrefs()); } catch {}
}
